import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.disability;

export const getDisabilityPlansSelector = createSelector(
  getState,
  (state) => state.disabilityPlans,
);
